import React from 'react';
import { WebhooksExample } from './WebhooksExample';
import { ObjectExample } from './ObjectExample';
import { OperationExample } from './OperationExample';

export const ExampleCodeSwitch = ({ example, data, JSLayoutType }) => {
  const { name, isEvent, isMainObject, isMainEntity, displayName, eventType } =
    data;

  if (isEvent) {
    return (
      <WebhooksExample
        example={example}
        displayName={displayName}
        eventType={eventType}
      />
    );
  }
  if (isMainObject || isMainEntity) {
    return <ObjectExample name={name} example={example} />;
  }
  return (
    <OperationExample
      name={name}
      example={example}
      JSLayoutType={JSLayoutType}
    />
  );
};
